import { createParser, validators } from '@walmart/sophia-tagging'

export default createParser({
  fields: [{ from: 'productId', to: 'sku', validate: [validators.isRequired] }],
})
